import { render } from "./AppClockBlock.vue?vue&type=template&id=490a65ee&scoped=true"
import script from "./AppClockBlock.vue?vue&type=script&lang=js"
export * from "./AppClockBlock.vue?vue&type=script&lang=js"

import "./AppClockBlock.vue?vue&type=style&index=0&id=490a65ee&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490a65ee"]])

export default __exports__